import React, { Component } from 'react';
import FamilyMemberTable from 'modules/family/components/family-member-table/family-member-table'
import { withNamespaces } from 'react-i18next';
import AddMemberButton from 'modules/family/components/add-member/add-member-button';

@withNamespaces()
class ManageFamily extends Component {
    render() {
        const { t } = this.props;

        return (
            <div className="card">
                <div className="card-header">
                    <h3 className="card-title">{t('FAMILY.MANAGE.TABLE.TITLE')}</h3>
                    <div className="pull-right">
                        <AddMemberButton />
                    </div>
                </div>
                <FamilyMemberTable />
            </div>
        );
    }
}

export default ManageFamily;


// WEBPACK FOOTER //
// ./src/modules/family/pages/manage/manage-family.js